import script from "./UserJizenCode.vue?vue&type=script&setup=true&lang=js"
export * from "./UserJizenCode.vue?vue&type=script&setup=true&lang=js"

import "./UserJizenCode.vue?vue&type=style&index=0&id=52d2f120&lang=css"

const __exports__ = script;

export default __exports__